export * from './register-page.component';
